module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.to')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Email to",
      "filter-method": _vm.optionFilter,
      "multiple": true,
      "filterable": true,
      "allow-create": true,
      "popper-class": "ccEmail"
    },
    model: {
      value: (_vm.previewEmailTo),
      callback: function($$v) {
        _vm.previewEmailTo = $$v
      },
      expression: "previewEmailTo"
    }
  }, _vm._l((_vm.to), function(email, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": email,
        "value": email
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" CC:")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Email cc",
      "filter-method": _vm.optionFilter,
      "multiple": true,
      "filterable": true,
      "allow-create": true,
      "popper-class": "ccEmail hidden"
    },
    model: {
      value: (_vm.previewEmailCC),
      callback: function($$v) {
        _vm.previewEmailCC = $$v
      },
      expression: "previewEmailCC"
    }
  }, _vm._l((_vm.previewEmailCC), function(email, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": email,
        "value": email
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.subject')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    attrs: {
      "name": "subject"
    },
    model: {
      value: (_vm.previewSubject),
      callback: function($$v) {
        _vm.previewSubject = $$v
      },
      expression: "previewSubject"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-textarea margin-b-10"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.messageBody')) + ":")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewMessage),
      expression: "previewMessage"
    }],
    staticClass: "el-textarea__inner",
    attrs: {
      "rows": "10",
      "name": "message"
    },
    domProps: {
      "value": (_vm.previewMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previewMessage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.modalButtonLoading
    },
    on: {
      "click": _vm.buttons[0].action
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttons[0].name) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.modalButtonLoading
    },
    on: {
      "click": _vm.sendReminder
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttons[1].name) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c215caa","hasScoped":false}!./src/app/components/previewMessageReminder/previewMessageReminder.html
// module id = 2908
// module chunks = 1